import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        confirmed: '=',
        declined: '='
    },
    template: `
        <div class="col00 small">
            <alert-success ng-if="vm.confirmed && !vm.declined">{{ 'performanceReview.Answers confirmed. Thank you' | translate }}</alert-success>
            <alert-success ng-if="!vm.confirmed && !vm.declined">{{ 'performanceReview.Answers submitted. Thanks for answering.' | translate }}</alert-success>
            <alert-success ng-if="!vm.confirmed && vm.declined">{{ 'performanceReview.Decline notification sent' | translate }}</alert-success>
        </div>
    `
})
export default class {
    constructor (WindowConfirmService) {
        this.WindowConfirmService = WindowConfirmService;
    }

    $onInit () {
        this.WindowConfirmService.deactivate();
    }
}




// WEBPACK FOOTER //
// ./src/app/components/review/default/finished/index.js